
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getDepartmentList } from '@/api/company';
import { getEngineerList } from '@/api/users';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'DialogSelectEngineer',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  selectedEngineervisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })
  selectedEngineer!: any;

  private formSearch: any = {
    name: ''
  }
  private tableData: any = []
  private selectedData:any = {}
  private loading = false;

  private page:number=1;
  private pageCount:number=1;
  created() {
    this.getList();
  }
  private getList() {
    this.loading = true;
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.page,
      size: 10
    };
    if (this.formSearch.name) {
      params.name = this.formSearch.name;
    }
    getEngineerList(params)
      .then((res) => {
        if (res.data) {
          this.pageCount = res.data.page_count;
          if (this.page === 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
        } else {
          this.pageCount = 0;
          this.tableData = []
        }
        // 有没有分页自己在看接口
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        let msg = err.msg;
      });
  }
  private moreHandle() {
    this.page = this.page + 1;
    this.getList();
  }
  private searchHandle() {
    this.page = 1;
    this.selectedData = {};
    this.getList();
  }
  private clearHandle() {
    this.formSearch.name = '';
    this.selectedData = {};
    this.getList();
  }
  private confirmHandle() {
    this.$emit('confirmHandle', this.selectedData);
    this.close();
  }
  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
